import {
  CLEAR_CART_WISHLIST_SEARCH,
  FETCH_CART_WISHLIST_SEARCH,
  FETCH_CART_WISHLIST_SEARCH_FULFILLED,
  FETCH_CART_WISHLIST_SEARCH_REJECTED,
} from './actionTypes';
import {
  CartWishlistSearchType,
  ClearCartWishlistSearchAction,
  FetchCartWishlistSearchAction,
  FetchCartWishlistSearchFulfilledAction,
  FetchCartWishlistSearchRejectedAction,
} from './types';

const fetchCartWishlistSearch = (
  query: string,
): FetchCartWishlistSearchAction => ({
  type: FETCH_CART_WISHLIST_SEARCH,
  payload: {
    query,
  },
});

const fetchCartWishlistSearchFulfilled = (
  response: CartWishlistSearchType,
): FetchCartWishlistSearchFulfilledAction => ({
  type: FETCH_CART_WISHLIST_SEARCH_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchCartWishlistSearchRejected = (
  error: ErrorType,
): FetchCartWishlistSearchRejectedAction => ({
  type: FETCH_CART_WISHLIST_SEARCH_REJECTED,
  payload: {
    error,
  },
});

const clearCartWishlistSearch = (): ClearCartWishlistSearchAction => ({
  type: CLEAR_CART_WISHLIST_SEARCH,
});

export {
  clearCartWishlistSearch,
  fetchCartWishlistSearch,
  fetchCartWishlistSearchFulfilled,
  fetchCartWishlistSearchRejected,
};
